import { render, staticRenderFns } from "./SpecialEventDetail.vue?vue&type=template&id=01e12a7c&scoped=true"
import script from "./SpecialEventDetail.vue?vue&type=script&lang=js"
export * from "./SpecialEventDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialEventDetail.vue?vue&type=style&index=0&id=01e12a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e12a7c",
  null
  
)

export default component.exports